import { Link } from '@mui/material';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { GridInitialStateCommunity } from '@mui/x-data-grid/models/gridStateCommunity';
import { Countdown } from 'components/common/Countdown';
import { EventActionMenu } from 'components/event/actionMenu/EventActionMenu';
import { EventListProps } from 'components/event/EventList';
import dayjs from 'dayjs';
import { deepmergeCustom } from 'deepmerge-ts';
import { EventOccasion } from 'models/EventOccasion';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';

const deepmergeInitialState = deepmergeCustom<GridInitialStateCommunity | undefined>({
  mergeArrays: false,
});

export function EventTable(props: EventListProps) {
  const { t } = useTranslation();
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const initialState = deepmergeInitialState(
    {
      pagination: {
        paginationModel: {
          pageSize: 25,
        },
      },
      sorting: {
        sortModel: [
          {
            field: 'date',
            sort: 'asc',
          },
        ],
      },
    },
    props.initialState
  );

  const columns: GridColDef[] = [
    {
      field: 'name',
      headerName: t('name', 'Name'),
      minWidth: 250,
      flex: 1,
      renderCell: (params) => (
        <Link underline="hover" color="inherit" component={RouterLink} to={`/events/${params.id}`}>
          {params.value}
        </Link>
      ),
    },
    {
      field: 'date',
      headerName: t('date', 'Date'),
      minWidth: 150,
      valueFormatter: (value) => dayjs(value).format('L LT'),
      sortComparator: (e1: EventOccasion, e2: EventOccasion) => {
        const date1 = new Date(e1.date);
        const date2 = new Date(e2.date);
        return date1 < today ? 1 : date2 < today ? -1 : date1.getTime() - date2.getTime();
      },
    },
    {
      field: 'expireDate',
      headerName: t('expireDate', 'Request Expire'),
      minWidth: 150,
      valueFormatter: (value) => dayjs(value).format('L LT'),
      renderCell: (params) => {
        const expired = params.value ? new Date() > new Date(params.value) : false;
        return expired ? t('expired', 'Expired') : <Countdown targetDate={params.value} />;
      },
    },
    // {
    //   field: 'requests',
    //   headerName: 'Requests',
    //   minWidth: 150,
    //   renderCell: (params) => (params.row as IEvent).requests?.length,
    // },
    // {
    //   field: 'tracks',
    //   headerName: 'Tracks in Playlist',
    //   minWidth: 150,
    //   renderCell: (params) => (params.row as IEvent).requests?.filter(req => !req.isDeleted).length,
    //   sortComparator: (tracks1: Request[], tracks2: Request[]) => {
    //     const count1 = tracks1?.filter(req => !req.isDeleted).length || 0;
    //     const count2 = tracks2?.filter(req => !req.isDeleted).length || 0;
    //     return count1 < count2 ? 1 : -1;
    //   }
    // },
    {
      field: 'actions',
      headerName: '',
      sortable: false,
      width: 60,
      renderCell: (params) => (
        <EventActionMenu
          event={params.row as EventOccasion}
          onDeleteEvent={props.onDeleteEvent}
          onRestoreEvent={props.onRestoreEvent}
        />
      ),
    },
  ];

  return (
    <DataGrid
      sx={{ border: 0 }}
      rows={props.eventList}
      columns={columns}
      initialState={initialState}
      pageSizeOptions={[25, 50, 100]}
      checkboxSelection
      disableColumnMenu
      disableRowSelectionOnClick
    />
  );
}
